import type { Guide, GuideRecordHint } from '../types';

/**
 * S-21.10-14 — połączenie prezlecenia z TMS mimo innego kontrahenta (scenariusz e2e 20, krok 20.3; decyzja
 * użytkownika 21.10.2026, pkt 18). Zlecenie DEMO/2026/10/A01 ma znacznik do sprawdzenia tak, jak zostawia go
 * import po numerze zamówienia klienta (`seed-e2e.ts`).
 */
const LINKED_ORDER: GuideRecordHint = {
  description: 'zlecenie z TMS ze znacznikiem „Połączono z TMS mimo innego kontrahenta — sprawdź”',
  listPath: '/user-offers',
  listFilter: { forklift: 'hide' },
};

export const guide: Guide = {
  flagKey: 'preOrderLinkOtherContractor',
  title: 'Połączenie prezlecenia z TMS mimo innego kontrahenta',
  whatItDoes:
    'Gdy zlecenie z TMS ma numer zamówienia klienta z prezlecenia, ale innego kontrahenta niż wybrany na prezleceniu, import i tak łączy oba wiersze w jedno zlecenie — obowiązuje kontrahent z TMS. Dotąd takie połączenie czekało jako „możliwe połączenie” na decyzję człowieka. Teraz karta zlecenia dostaje znacznik „Połączono z TMS mimo innego kontrahenta — sprawdź”, a historia zlecenia wpis z ostrzeżeniem; przyjęcie zleceń sprawdza połączenie i zdejmuje znacznik przyciskiem „Sprawdziłem”.',
  audience: ['CS', 'Administracja'],
  presentationItems: ['S-21.10-14'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: LINKED_ORDER,
      target: 'contractor-link-check',
      title: 'Znacznik na karcie zlecenia',
      description:
        'Nad kartą zlecenia: po jakim numerze zamówienia klienta import połączył prezlecenie i że obowiązuje kontrahent z TMS. Znacznik widzi przyjęcie zleceń (CS i Administracja).',
      action: 'Sprawdź, czy to ten sam transport i właściwy kontrahent — porównaj z prezleceniem i historią zlecenia.',
      recorder: { account: 'adm', demo: { kind: 'order', number: 'DEMO/2026/10/A01' } },
    },
    {
      route: '/user-offers/:orderId/show',
      record: LINKED_ORDER,
      target: 'contractor-link-check-confirm',
      title: '„Sprawdziłem”',
      description:
        'Po sprawdzeniu znacznik zdejmuje „Sprawdziłem”, z komentarzem albo bez. Potwierdzenie zostaje w historii zlecenia, nic innego się nie zmienia.',
      action: 'Wpisz komentarz (nieobowiązkowy) i kliknij „Sprawdziłem”.',
      recorder: { account: 'adm', demo: { kind: 'order', number: 'DEMO/2026/10/A01' } },
    },
  ],
};
